import { render, staticRenderFns } from "./index.vue?vue&type=template&id=55aeccfa"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=55aeccfa&lscoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55aeccfa')) {
      api.createRecord('55aeccfa', component.options)
    } else {
      api.reload('55aeccfa', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=55aeccfa", function () {
      api.rerender('55aeccfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemSetting/design/theme/index.vue"
export default component.exports